module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('part-item', {
    attrs: {
      "title": _vm.$t('partner')
    }
  }, [_c('content-item', {
    attrs: {
      "marginTop": 0
    }
  }, [_c('div', {
    staticClass: "partner-content"
  }, _vm._l((4), function(row) {
    return _c('div', {
      staticClass: "hex-row",
      class: row % 2 == 0 ? 'hex-gap' : ''
    }, [(row % 2 == 0) ? _vm._l((8), function(col) {
      return _c('div', {
        staticClass: "hex-col"
      }, [_c('div', {
        staticClass: "hexagon",
        class: 'icon' + row + '' + col
      }, [(_vm.showIcon(row, col)) ? _c('div', {
        staticClass: "content"
      }, [_c('img', {
        directives: [{
          name: "lazy",
          rawName: "v-lazy",
          value: ('../../../static/img/home/brand_icon/icon' + row + '' + col + '.png'),
          expression: "'../../../static/img/home/brand_icon/icon' + row + '' + col + '.png'"
        }],
        staticClass: "icon"
      })]) : _vm._e()])])
    }) : _vm._l((8), function(col) {
      return _c('div', {
        staticClass: "hex-col"
      }, [_c('div', {
        staticClass: "hexagon",
        class: 'icon' + row + '' + col
      }, [(_vm.showIcon(row, col)) ? _c('div', {
        staticClass: "content"
      }, [_c('img', {
        directives: [{
          name: "lazy",
          rawName: "v-lazy",
          value: ('../../../static/img/home/brand_icon/icon' + row + '' + col + '.png'),
          expression: "'../../../static/img/home/brand_icon/icon' + row + '' + col + '.png'"
        }],
        staticClass: "icon"
      })]) : _vm._e()])])
    })], 2)
  }))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c2b5e786!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/Partner.vue
// module id = 390
// module chunks = 1